import React from "react";
import Chart from "react-apexcharts";

function ChartProcess() {
    const series = [8, 4, 12, 8, 8, 10, 2];
    const label_status =  ['Ack Job', 'Depart', 'On Site', 'Transfer', 'Close Job', 'Stop Time', 'Over due'] ;
    const options = {
        chart: {
            width: '100%'
        },
        colors: ['#0AB8D8', '#1277DB', '#E6ED2B', '#B248BF', '#19DDA1', '#F76416', '#DF3034'],
        fill: {
            colors: ['#0AB8D8', '#1277DB', '#E6ED2B', '#B248BF', '#19DDA1', '#F76416', '#DF3034']
        },
        labels: ['Ack Job', 'Depart', 'On Site', 'Transfer', 'Close Job', 'Stop Time', 'Over due'],
        dataLabels: {
            enabled: true,
            enabledOnSeries: undefined,
            style: {
                colors: ['#fff', '#fff'] , 
                margin : "20 , 20 , 20 , 20"
            },
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]  + "\n" + label_status[opts.seriesIndex]
            },
        },
        legend: {
            show: false
        },
        plotOptions: {
            pie: {
                customScale: 1.1,
                donut: {
                    size: '75%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '22px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 600,
                            color: "#333",
                            offsetY: -10,
                            formatter: function (val) {
                                return val
                            }
                        },
                        value: {
                            show: true,
                            fontSize: '28px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 600,
                            color: "#000F9F",
                            offsetY: 5,
                            formatter: function (val) {
                                console.log(val)
                                return val
                            }
                        },
                        total: {
                            show: true,
                            label: 'Job On Process',
                            fontSize: '11px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 400,
                            color: '#41434A',
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b
                                }, 0)
                            }
                        }
                    }
                },
            }
        }
    };




    return (
        <Chart options={options} series={series} type="donut" />
    )
}

export default ChartProcess














